export default class ClipboardCopy {
	constructor({ elements }) {
		elements.forEach((el) => {
			const targetElement = document.getElementById(`${el.dataset.clipboardCopy}`);
			el.addEventListener('click', (e) => {
				e.preventDefault();
				ClipboardCopy.getCopy(el, targetElement);
			});
		});
	}

	static getCopy(el, targetElement) {
		navigator.clipboard.writeText(targetElement.value);
		const infoBubble = el.previousElementSibling;
		if (infoBubble && infoBubble.classList.contains('hidden')) {
			infoBubble.classList.remove('hidden');
			setTimeout(() => {
				infoBubble.classList.add('hidden');
			}, 3000);
		}
	}
}
